import { AnyAction } from "redux";
import { FetchStatus, IFetchAction } from "../middleware/fetch-middleware";
import { ILiturgicalEventDto } from "../DTO/liturgical-calendar";
import * as moment from 'moment';
import * as _ from 'lodash';
import { LiturgicalCalendar } from "../../liturgical-calendar/components/liturgical-calendar-app";

export enum LiturgicalCalendarActions {
    GetLiturgicalEvents = 'apiLiturgicalCalendarActions/getLiturgicalEvents'
}

export interface LiturgicalCalendarState {
    events: ILiturgicalEventDto[];
}

const DefaultLiturgicalCalendarState: LiturgicalCalendarState = {
    events: []
}


export const litugricalCalendarApiReducer = (state = DefaultLiturgicalCalendarState, action: AnyAction) => {
    switch (action.type) {
        case LiturgicalCalendarActions.GetLiturgicalEvents + FetchStatus.Complete:
            return { ...state, events: addEvents(action.data) };

        default: return state;
    }
}

const addEvents = (events: ILiturgicalEventDto[]) => {
    events = events.map(event => {
        return {
            ...event,
            eventDateTime: moment.default(event.eventDate)
        }
    }).sort((a, b) => sortEvents(a, b));
    return events;
}

const sortEvents = (a: ILiturgicalEventDto, b: ILiturgicalEventDto) => {
    let aDate = a.eventDateTime;
    let bDate = b.eventDateTime;

    if (aDate > bDate)
        return 1;
    if (aDate < bDate)
        return -1;
    if (aDate === bDate)
        return 0;
}

const BaseUrl = '/api/v1/liturgicalCalendar';

export const getLiturgicalEvents = (date: moment.Moment): IFetchAction => ({
    type: LiturgicalCalendarActions.GetLiturgicalEvents,
    fetch: new Request(`${BaseUrl}/liturgicalEvents?date=${date.format('YYYY-MM-DDTHH:mm:ss')}`, {
        method: 'GET',
    })
})


